import styled, { css } from "styled-components";

export const ChildrenWrapper = styled.div`
  ${({ theme }) => css`
    max-height: ${p => p.calendar ? 'none' : '300px'};
    min-width:  ${p => p.calendar ? 'none' : '320px'};

    border: ${p => p.calendar ? 'none' : '1px solid #E3E3E3'};
    border-radius: 8px;

    overflow-y: auto;

    ${p => p.hasTop && css`
      border-top-width: 0px;
      border-radius: 0px 0px 8px 8px;
    `}

    @media screen and (min-width: 768px){
      scrollbar-width: thin;
      scrollbar-color: #E3E3E3 transparent;
    }

      /* width */
    ::-webkit-scrollbar {
      width: 4px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      border-radius: 10px;
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #A5E5C4; 
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #A5E5C4; 
    }
  `}
`;